import { jsx as o } from "react/jsx-runtime";
import { I } from "../chunks/index.ed48ee81.js";
import { m as g } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as h } from "react";
import { c as x } from "../chunks/common.4b17d1d1.js";
const w = h(
  ({
    "aria-label": e,
    a11yLabel: a,
    a11yTitle: s,
    className: n,
    icon: l,
    isDecorative: m = !1,
    size: c = "large",
    title: f,
    variant: i = "default",
    ...p
  }, u) => {
    const { $el: b } = g(u, ["$el"]), d = x({
      className: n,
      size: c,
      variant: i
    }), t = {
      "aria-label": e || a,
      className: d,
      title: f || s,
      ref: b,
      ...p
    }, r = /* @__PURE__ */ o(I, { icon: l });
    return m ? /* @__PURE__ */ o(
      "span",
      {
        role: "figure",
        ...t,
        children: r
      }
    ) : /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        ...t,
        children: r
      }
    );
  }
);
export {
  w as ButtonIcon
};
//# sourceMappingURL=ButtonIcon.js.map
